// src/components/Footer.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, MessageCircle } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="mb-4 font-serif text-2xl font-bold">Nazilli Family Apart</h3>
            <p className="mb-4 max-w-md text-primary-foreground/80">
              Nazilli&apos;de aile dostu, temiz ve konforlu konaklama hizmeti
              sunuyoruz. Merkezi konumumuz ve kaliteli hizmetimizle unutulmaz bir
              deneyim yaşayın.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="mb-4 font-serif text-lg font-semibold">Hızlı Linkler</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-primary-foreground/80 transition-colors hover:text-primary-foreground"
                >
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link
                  to="/hakkimizda"
                  className="text-primary-foreground/80 transition-colors hover:text-primary-foreground"
                >
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link
                  to="/odalar"
                  className="text-primary-foreground/80 transition-colors hover:text-primary-foreground"
                >
                  Odalar
                </Link>
              </li>
              <li>
                <Link
                  to="/galeri"
                  className="text-primary-foreground/80 transition-colors hover:text-primary-foreground"
                >
                  Galeri
                </Link>
              </li>
              <li>
                <Link
                  to="/iletisim"
                  className="text-primary-foreground/80 transition-colors hover:text-primary-foreground"
                >
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="mb-4 font-serif text-lg font-semibold">İletişim</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4" />
                <span className="text-primary-foreground/80">+90 506 256 2324</span>
              </li>
              <li className="flex items-center gap-2">
                <MessageCircle className="h-4 w-4" />
                <span className="text-primary-foreground/80">WhatsApp Destek</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                <span className="text-primary-foreground/80">
                  info@nazillifamilyapart.com
                </span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="mt-1 h-4 w-4" />
                <span className="text-primary-foreground/80">
                  Nazilli Merkez
                  <br />
                  Aydın, Türkiye
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t border-primary-foreground/20 pt-8 text-center">
          <p className="text-primary-foreground/60">
            © 2024 Nazilli Family Apart. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
}
